import { render } from "./ProfileSmallInfo.vue?vue&type=template&id=deeeb778&lang=pug"
import script from "./ProfileSmallInfo.vue?vue&type=script&lang=js"
export * from "./ProfileSmallInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__